<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> OTA Batch Details </span>
    </div>
    <div class="button-group">
      <app-ota-info></app-ota-info>
    </div>
  </div>
  <form [formGroup]="deviceOTAForm" novalidate>
    <!-- Ota Batch Details Section -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">OTA Batch Details</h6>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <div class="form-section">
          <!-- Batch ID -->
          <div class="form-group">
            <label for="batchId" class="form-label">Batch ID</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch ID</mat-label>
              <input
                matInput
                readonly
                placeholder="OTA Batch Id"
                [value]="OtaBatchId"
              />
            </mat-form-field>
          </div>
          <!-- Batch Name -->
          <div class="form-group">
            <label for="batchName" class="form-label">Batch Name</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch Name</mat-label>
              <input
                matInput
                readonly
                [value]="OtaBatchName"
                placeholder="Batch Name"
              />
            </mat-form-field>
          </div>
          <!-- Batch Description -->
          <div class="form-group">
            <label for="batchDescription" class="form-label"
              >Batch Description</label
            >
            <mat-form-field appearance="outline">
              <mat-label>Batch Description</mat-label>
              <input
                matInput
                readonly
                placeholder="Batch Description"
                [value]="OtaBatchDescription"
              />
            </mat-form-field>
          </div>
          <!-- Batch Date -->
          <div class="form-group">
            <label for="batchDate" class="form-label">Batch Date</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch Date</mat-label>
              <input
                matInput
                readonly
                placeholder="Batch Date"
                [value]="OtaBatchDate"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <!-- KPI Section -->
    <div class="kpi-section">
      <!-- Total Uploaded Devices -->
      <div
        class="kpi-card kpi-gradient-blue"
        (click)="changeKPISelected('All')"
        tabindex="0"
        (keydown.enter)="changeKPISelected('All')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >Total Uploaded Devices
            <app-info-tooltip
              block
              heading="Total Uploaded Devices"
              [description]="kpiInfo.totalUploaded"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (totalUploaded ? totalUploaded : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            src="../../assets/uploaded.png"
            alt="Total Uploaded Devices Image"
          />
        </div>
      </div>

      <!-- Total In-Progress Devices -->
      <div
        class="kpi-card kpi-gradient-purple"
        (click)="changeKPISelected('In-Progress')"
        tabindex="0"
        (keydown.enter)="changeKPISelected('In-Progress')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >Total In-Progress Devices
            <app-info-tooltip
              block
              heading="Total In-Progress Devices"
              [description]="kpiInfo.inProgress"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (totalInProgress ? totalInProgress : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            src="../../assets/initiated.png"
            alt="Total In-Progress Devices Image"
          />
        </div>
      </div>

      <!-- Total Aborted Devices -->
      <div
        class="kpi-card kpi-gradient-pink"
        (click)="changeKPISelected('Aborted')"
        tabindex="0"
        (keydown.enter)="changeKPISelected('Aborted')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >Total Aborted Devices
            <app-info-tooltip
              block
              heading="Total Aborted Devices"
              [description]="kpiInfo.aborted"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (totalAborted ? totalAborted : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            src="../../assets/aborted.png"
            alt="Total Aborted Devices Image"
          />
        </div>
      </div>

      <!-- Total Completed Devices -->
      <div
        class="kpi-card kpi-gradient-green"
        (click)="changeKPISelected('Completed')"
        tabindex="0"
        (keydown.enter)="changeKPISelected('Completed')"
      >
        <div class="kpi-details">
          <span class="kpi-content"
            >Total Completed Devices
            <app-info-tooltip
              block
              heading="Total Completed Devices"
              [description]="kpiInfo.completed"
              (click)="$event.stopPropagation()"
            ></app-info-tooltip
          ></span>
          <span class="kpi-value">
            {{ (totalCompleted ? totalCompleted : 0) | indianNumber }}
          </span>
        </div>
        <div class="kpi-visual">
          <img
            src="../../assets/completed-task.png"
            alt="Total Completed Devices Image"
          />
        </div>
      </div>
    </div>

    <div class="component-container" #tableContainer>
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">{{ kpiSelected }} OTA Batch Device List</h6>
        <div class="component-actions">
          <app-common-search
            [initialSearchValue]="
              deviceOTAForm?.get('batchDetailsSearch')?.value
            "
            [placeHolder]="'Search by IMEI and Press Enter'"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>IMEI</th>
              <th>OTA Triggered</th>
              <th>OTA Response</th>
              <th>Remark</th>
              <th>Updated At</th>
              @if (deleteOta) {
                <th>Action</th>
              }
            </tr>
          </thead>
          @if (deviceList.length > 0) {
            <tbody>
              @for (
                device of deviceList
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track device;
                let i = $index
              ) {
                @for (
                  command of device.commands;
                  track command;
                  let j = $index
                ) {
                  <tr
                    [ngClass]="{
                      'red-row': device.isAborted,
                      'green-row':
                        device.deviceStatus === 'Completed' &&
                        !device.isAborted,
                    }"
                    [matTooltip]="
                      device.isAborted ? device.abortReason || 'Aborted' : ''
                    "
                  >
                    <!-- Only include IMEI in the first row -->
                    @if (j === 0) {
                      <td [attr.rowspan]="device?.commands?.length">
                        {{ device.imei || '' }}
                      </td>
                    }
                    <td>{{ command.command || '' }}</td>
                    <td>{{ command?.response || '--' }}</td>
                    <td>{{ command.status || '' }}</td>
                    <td>
                      {{
                        command.updatedAt && command.updatedAt !== ''
                          ? (command.updatedAt
                            | date: 'dd MMM yyyy | hh:mm:ss a')
                          : '--'
                      }}
                    </td>
                    <!-- Only include Action in the first row -->
                    @if (j === 0 && deleteOta) {
                      <td [attr.rowspan]="device?.commands?.length">
                        <div class="action-buttons">
                          <button
                            type="button"
                            class="primary-button abort-button"
                            [disabled]="
                              device.isAborted ||
                              device.deviceStatus === 'Completed'
                            "
                            (click)="deleteOtaBatchDetails(device._id)"
                          >
                            <mat-icon class="btn-icon">block</mat-icon>
                          </button>
                        </div>
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="6">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        @if (totalLength > 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </form>
</div>
